module.exports =
`
# 広告掲載

MUZIK Air（ムジークエア）は世界トップのクラシック音楽プラットフォーム。MUZIK Airは世界のクラシックニュースをまとめて，いろんな曲を気楽に聴きのためにシナリオを企画。クラシック音楽を愛する人は、MUZIK Airを通じてあなたと繋がります。ご意見・ご提案がございましたら ，下のフォームに入力してください，当社スタッフが迅速に対応いたします。

`
